import {personHandlers} from './personHandlers';
import {teamHandlers} from './teamHandlers';
import {roleHandlers} from './roleHandlers';
import {projectHandlers} from './projectHandlers';
import {phaseHandlers} from './phaseHandlers';
import {assignmentHandlers} from './assignmentHandlers';
import {allocationHandlers} from './allocationHandlers';
import {availabilityHandlers} from './availabilityHandlers';
import {tagHandlers} from './tagHandlers';
import {projectPersonHandlers} from './projectPersonHandlers';
import {configHandlers} from './configHandlers';

export const signalRHandlers = {
    ...personHandlers,
    ...teamHandlers,
    ...roleHandlers,
    ...projectHandlers,
    ...phaseHandlers,
    ...assignmentHandlers,
    ...allocationHandlers,
    ...availabilityHandlers,
    ...tagHandlers,
    ...projectPersonHandlers,
    ...configHandlers
};

export type SignalREventType = keyof typeof signalRHandlers;
